// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1aYIg","clinicsSelect":"TableHeading_clinicsSelect__3Dvl2"};